import { smsPlatform } from '@/api/index'

export function getSmsClassData (data) {
  return smsPlatform.request({
    method: 'post',
    url: '/GetSmsClassData',
    data
  })
}

export function getClassName (data) {
  return smsPlatform.request({
    method: 'post',
    url: '/GetClassName',
    data
  })
}

export function saveSmsModel (data) {
  return smsPlatform.request({
    method: 'post',
    url: '/SaveSmsModel',
    data
  })
}

export function getSmsModelData (data) {
  return smsPlatform.request({
    method: 'post',
    url: '/GetSmsModelData',
    data,
    // 设置识别为formData的数据
    iSFromData: true

  })
}
export function getSmsManDataNew (data) {
  return smsPlatform.request({
    method: 'post',
    url: '/GetSmsManData_new',
    data,
    iSFromData: true
  })
}

export function uploadExecl (data) {
  return smsPlatform.request({
    method: 'post',
    url: '/UploadExecl',
    data
    // iSFromData: true
  })
}

export function getSMSCost (data) {
  return smsPlatform.request({
    method: 'post',
    url: '/getSMSCost',
    data
    // iSFromData: true
  })
}
